"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var Button_1 = __importDefault(require("../Button"));
var styles_1 = require("./styles");
var EditableFormFooter = function (_a) {
    var onSave = _a.onSave, onCancel = _a.onCancel, disabledSave = _a.disabledSave, disabledCancel = _a.disabledCancel, isLoading = _a.isLoading, cancelButtonLabel = _a.cancelButtonLabel, saveButtonLabel = _a.saveButtonLabel;
    return ((0, jsx_runtime_1.jsxs)(styles_1.Container, { children: [(0, jsx_runtime_1.jsx)(Button_1.default, __assign({ onClick: onCancel, type: "button", disabled: disabledCancel, "data-testid": "editable-form-footer-cancel" }, { children: cancelButtonLabel })), (0, jsx_runtime_1.jsx)(Button_1.default, __assign({ onClick: onSave, variant: "primary", disabled: disabledSave, loading: isLoading, "data-testid": "editable-form-footer-save" }, { children: saveButtonLabel }))] }));
};
exports.default = EditableFormFooter;
